import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { changeRequestsActions } from "../actions";
import api from "../services/changeRequests.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { changeRequestPagination } from "../selectors/changeRequests.selector";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { getProjectBudgetSummary } from "../actions/projects.actions";
import { getPortFolioBudgetSummary } from "../actions/portfolio.actions";
import { getProgramBudgetSummary } from "../actions/programs.actions";

function* sortChangeRequests(state) {
  try {
    yield put(changeRequestsActions.sortChangeRequestRequestAttempt.pending);
    const ChangeRequest = yield call(api.sortChangeRequests, state.payload);
    const pagination = JSON.parse(ChangeRequest.headers["x-pagination"]);
    const data = {
      data: ChangeRequest.data,
      pagination: pagination,
    };
    yield put(
      changeRequestsActions.sortChangeRequestRequestAttempt.success(data)
    );
  } catch (error) {
    yield put(
      changeRequestsActions.sortChangeRequestRequestAttempt.error(error.message)
    );
  }
}

function* getChangeRequests(state) {
  try {
    yield put(changeRequestsActions.getChangeRequestsAttempt.pending);
    const ChangeRequest = yield call(api.getChangeRequests, state.payload);
    const pagination = JSON.parse(ChangeRequest.headers["x-pagination"]);
    const data = {
      data: ChangeRequest.data,
      pagination: pagination,
    };
    yield put(changeRequestsActions.getChangeRequestsAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(changeRequestsActions.getChangeRequestsAttempt.error(""));
    } else {
      yield put(
        changeRequestsActions.getChangeRequestsAttempt.error(error.message)
      );
    }
  }
}

function* createChangeRequest(state) {
  try {
    yield put(changeRequestsActions.createChangeRequestAttempt.pending);
    yield call(api.createChangeRequest, state.payload);
    if (state.payload.parent == "Project") {
      yield put(getProjectBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramBudgetSummary({ id: state.payload.parentID }));
    }
    // const paginat = yield select(changeRequestPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: 1,
      size: state.payload.perPageItems,
    };
    const ChangeRequests = yield call(api.getChangeRequests, payload);
    const pagination = JSON.parse(ChangeRequests.headers["x-pagination"]);
    const data = {
      data: ChangeRequests.data,
      pagination: pagination,
    };
    yield put(changeRequestsActions.createChangeRequestAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Change request saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        changeRequestsActions.createChangeRequestAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        changeRequestsActions.createChangeRequestAttempt.error(errorObject.data)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        changeRequestsActions.createChangeRequestAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updateChangeRequest(state) {
  try {
    yield put(changeRequestsActions.updateChangeRequestAttempt.pending);
    yield call(api.updateChangeRequest, state.payload);
    if (state.payload.parent == "Project") {
      yield put(getProjectBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramBudgetSummary({ id: state.payload.parentID }));
    }
    const paginat = yield select(changeRequestPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const changeRequests = yield call(api.getChangeRequests, payload);
    const pagination = JSON.parse(changeRequests.headers["x-pagination"]);
    const data = {
      data: changeRequests.data,
      pagination: pagination,
    };
    yield put(changeRequestsActions.updateChangeRequestAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Change request updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        changeRequestsActions.updateChangeRequestAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        changeRequestsActions.updateChangeRequestAttempt.error(errorObject.data)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        changeRequestsActions.updateChangeRequestAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deletechangeRequest(state) {
  try {
    yield put(changeRequestsActions.deleteChangeRequestAttempt.pending);
    yield call(api.deleteChangeRequest, state.payload);
    if (state.payload.parent == "Project") {
      yield put(getProjectBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Portfolio") {
      yield put(getPortFolioBudgetSummary({ id: state.payload.parentID }));
    }
    else if (state.payload.parent == "Program") {
      yield put(getProgramBudgetSummary({ id: state.payload.parentID }));
    }
    const paginat = yield select(changeRequestPagination);
    const payload = {
      id: state.payload.parentID,
      parent: state.payload.parent,
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    };
    const changeRequests = yield call(api.getChangeRequests, payload);
    const pagination = JSON.parse(changeRequests.headers["x-pagination"]);
    const data = {
      data: changeRequests.data,
      pagination: pagination,
    };
    yield put(changeRequestsActions.deleteChangeRequestAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Change request deleted",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        changeRequestsActions.deleteChangeRequestAttempt.error(error.message)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        changeRequestsActions.deleteChangeRequestAttempt.error(errorObject.data)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        changeRequestsActions.deleteChangeRequestAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.message,
          type: "error",
        })
      );
    }
  }
}

function* createChangeRequestRisk(state) {
  try {
    yield put(changeRequestsActions.createRiskRequestAttempt.pending);
    yield call(api.createChangeRequestRisk, state.payload);
    yield put(changeRequestsActions.createRiskRequestAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Risk saved",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      changeRequestsActions.createRiskRequestAttempt.error(error.message)
    );
  }
}

function* updateChangeRequestFlag(state) {
  try {
    yield put(changeRequestsActions.updateChangeRequestFlagAttempt.pending);
    yield call(api.updateChangeRequestFlag, state.payload);
    yield put(changeRequestsActions.updateChangeRequestFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Change request flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(
      changeRequestsActions.updateChangeRequestFlagAttempt.error(error.message)
    );
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SORT_CHANGE_REQUEST_CALL, sortChangeRequests),
    takeEvery(ACTIONS.CHANGE_REQUEST_CALL, getChangeRequests),
    takeEvery(ACTIONS.CREATE_CHANGE_REQUEST_CALL, createChangeRequest),
    takeEvery(ACTIONS.UPDATE_CHANGE_REQUEST_CALL, updateChangeRequest),
    takeEvery(ACTIONS.DELETE_CHANGE_REQUEST_CALL, deletechangeRequest),
    takeEvery(ACTIONS.CREATE_CHANGE_REQUEST_RISK_CALL, createChangeRequestRisk),
    takeEvery(ACTIONS.CHANGE_REQUEST_FLAG_CALL, updateChangeRequestFlag),
  ]);
}
